export class LocalTrack {
    baseTrack;
    clonedTracks = [];
    constructor(baseTrack) {
        this.baseTrack = baseTrack;
    }
    get() {
        return this.baseTrack;
    }
    clone() {
        const clonedTrack = new LocalTrack(this.baseTrack.clone());
        this.clonedTracks.push(clonedTrack);
        return clonedTrack;
    }
    stop() {
        this.baseTrack.stop();
        this.clonedTracks.forEach((t) => t.stop());
        this.clonedTracks = [];
    }
}
//# sourceMappingURL=LocalTrack.js.map